<img [routerLink]="link" src="assets/images/logo/drone-deploy-logo-white.svg" />
